import { SearchChargerGroupsRequest } from '../../../core/cms-api/models';
import { Pagination } from '../../../shared/models/list.page.model';
import { ChargerGroupFilter } from '../store/charger-group.models';
import * as paginationConstants from '../../../shared/constants/pagination.constants';

export class ChargerGroupsRequestUtil {
  static createChargerGroupListRequest(
    operatorId: string,
    pagination?: Pagination | null,
    filter?: ChargerGroupFilter | null
  ): SearchChargerGroupsRequest {
    return {
      operatorId: operatorId,
      pageIndex: pagination?.pageIndex ?? 0,
      pageSize: pagination?.pageSize ?? paginationConstants.DefaultPageSize,
      name: filter?.groupName,
      minChargers: filter?.chargersRange ? filter?.chargersRange[0] : undefined,
      maxChargers: filter?.chargersRange ? filter?.chargersRange[1] : undefined,
      minConnectors: filter?.connectorsRange
        ? filter?.connectorsRange[0]
        : undefined,
      maxConnectors: filter?.connectorsRange
        ? filter?.connectorsRange[1]
        : undefined,
      minEnergy: filter?.energyRange ? filter?.energyRange[0] : undefined,
      maxEnergy: filter?.energyRange
        ? filter?.energyRange[1] * 1000
        : undefined,
      minTransactions: filter?.transactionsRange
        ? filter?.transactionsRange[0]
        : undefined,
      maxTransactions: filter?.transactionsRange
        ? filter?.transactionsRange[1]
        : undefined,
    } as SearchChargerGroupsRequest;
  }
}
